import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { companyService } from '@api/services/services';

type SetFieldValue = (field: string, value: unknown) => Promise<unknown> | unknown;

export const prefillPersonFromEmail = async (
  rawEmail: string | undefined,
  setFieldValue: SetFieldValue,
  pathPrefix?: string,
): Promise<SupplierEmployeeDto | undefined> => {
  const cleaned = rawEmail?.replace(/\s/g, '');
  if (!cleaned) return undefined;
  try {
    const res = await companyService.findSupplierEmployeeInCompany({ email: cleaned });
    const db = res.data;
    if (!db) return undefined;
    const prefix = pathPrefix ? `${pathPrefix}.` : '';
    if (db.name) await setFieldValue(`${prefix}name`, db.name);
    if (db.lastName) await setFieldValue(`${prefix}lastName`, db.lastName);
    if (db.phone) await setFieldValue(`${prefix}phone`, db.phone);
    if (db.email) await setFieldValue(`${prefix}email`, db.email);
    return db;
  } catch {
    return undefined;
  }
};
